// Le contexte Keycloak vit desormais dans @onclicks/keycloak, package auquel il
// appartient : il ne depend que de react et n'a rien de specifique au KMS.
// Ce shim preserve les imports existants de kmsApp et de kms7.
export type { KeycloakAuthResult } from '@onclicks/keycloak/providers/keycloakServiceProvider'
export { KeycloakAuthProvider, useAuth } from '@onclicks/keycloak/providers/keycloakServiceProvider'
